import { ApiMetric, ApiProject } from "@incendium/api";
import { useProjectSharedState } from "../../../Hooks/useSharedState";
import { getPrimaryAnalytics } from "../services/analyticsService";

export interface IHasSalesLastYear {
    hasSalesLastYear?: boolean;
    hasRevenueLastYear?: boolean;
}

const fetchHasSalesLastYear = async (selectedProject: ApiProject | null) => {
    if (selectedProject) {
        const res = await getPrimaryAnalytics(selectedProject.id as number, {
            yAxisKeys: [{
                key: "l",
                fields: [ApiMetric.METRIC_SALES_COUNT, ApiMetric.METRIC_REVENUE]
            }],
            attributes: [],
        }, undefined, undefined, 365)

        return {
            hasSalesLastYear: Number(res.chartData?.[0]?.[ApiMetric.METRIC_SALES_COUNT]) > 0,
            hasRevenueLastYear: Number(res.chartData?.[0]?.[ApiMetric.METRIC_REVENUE]) > 0,
        }
    }
    return {}
};
export const useHasSalesLastYear = () => {
    const { state, loading, refetch, fetched } = useProjectSharedState<IHasSalesLastYear>(
        "hasSalesLastYear",
        {},
        fetchHasSalesLastYear
    );
    return { state, loading, refetch, fetched };
};